import { Component, ViewChild } from '@angular/core';
import { AdminsWalletService } from '../../admin-wallet/admins-wallet.service';
import { MatTableDataSource } from '@angular/material/table';
import { PeriodicElement } from '../../admin-wallet/models/adminwallet.model';
import { CookieService } from 'ngx-cookie-service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-user-wallet-transaction',
  templateUrl: './user-wallet-transaction.component.html',
  styleUrls: ['./user-wallet-transaction.component.scss']
})
export class UserWalletTransactionComponent {



  allData: any = []; // Store all data
    dataSource: MatTableDataSource<PeriodicElement> = new MatTableDataSource()
    displayedColumns: string[] = ['Date' ,'Hash Code', 'direction', 'Sender', 'Receiver', 'value'];
    isLoading: boolean = false;
    token: any
    totalRows = 0;
    pageSize = 10;
    currentPage = 0;
    pageSizeOptions: number[] = [10, 20, 50]; // Page size options
  
    @ViewChild(MatPaginator)
    paginator!: MatPaginator;
    constructor(
      private adminServices: AdminsWalletService,
      private cookieService: CookieService,
    ) {
  
  
  
    }
  
    ngAfterViewInit() {
      this.dataSource.paginator = this.paginator;
    }
  
  
    ngOnInit() {
      this.token = this.cookieService.get('admin_token')
      this.getAdminWallet()
    }
  
    getAdminWallet() {
      this.adminServices.adminWalletTrxList(this.token).subscribe({
        next: async (v: any) => {
          if (v.success) {
            
            this.allData = v.normalTransactions;
            this.totalRows = this.allData.length;
            this.updateTableData();
            this.isLoading = false;
          }
          this.isLoading = false
        },
        error: (err:any) => {
          this.isLoading = false
          console.error('Error fetching data', err);
        }
      });
  
  
    }
  
  
    
    updateTableData(): void {
      const startIndex = this.currentPage * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      const paginatedData = this.allData.slice(startIndex, endIndex);
      this.dataSource = new MatTableDataSource(paginatedData);
  
      
    }
  
    pageChanged(event: PageEvent): void {
      this.currentPage = event.pageIndex;
      this.pageSize = event.pageSize;
      this.updateTableData();
    }
  
  
    
  
    
  
  
  }
  

